export interface Court {
  label: string
  value: string
  isJudgingOrgan?: boolean
  children?: {
    label: string
    value: string
    isJudgingOrgan?: boolean
    children?: {
      label: string
      value: string
      isJudgingOrgan?: boolean
    }[]
  }[]
  hasChildren?: boolean
}

export const courts: Court[] = [
  {
    label: 'Supremo Tribunal Federal',
    value: 'STF',
  },
  {
    label: 'Superior Tribunal de Justiça',
    value: 'STJ',
  },
  {
    label: 'Tribunal Superior do Trabalho',
    value: 'TST',
  },
  {
    label: 'Tribunais de Justiça',
    value: 'TJ',
    children: [
      {
        label: 'Tribunal de Justiça do Acre',
        value: 'TJ_AC',
      },
      {
        label: 'Tribunal de Justiça do Alagoas',
        value: 'TJ_AL',
      },
      {
        label: 'Tribunal de Justiça do Amapá',
        value: 'TJ_AP',
      },
      {
        label: 'Tribunal de Justiça do Amazonas',
        value: 'TJ_AM',
      },
      {
        label: 'Tribunal de Justiça da Bahia',
        value: 'TJ_BA',
      },
      {
        label: 'Tribunal de Justiça do Ceará',
        value: 'TJ_CE',
      },
      {
        label: 'Tribunal de Justiça do Distrito Federal',
        value: 'TJ_DF',
      },
      {
        label: 'Tribunal de Justiça do Espírito Santo',
        value: 'TJ_ES',
      },
      {
        label: 'Tribunal de Justiça de Goiás',
        value: 'TJ_GO',
      },
      {
        label: 'Tribunal de Justiça do Maranhão',
        value: 'TJ_MA',
      },
      {
        label: 'Tribunal de Justiça de Mato Grosso',
        value: 'TJ_MT',
      },
      {
        label: 'Tribunal de Justiça do Mato Grosso do Sul',
        value: 'TJ_MS',
      },
      {
        label: 'Tribunal de Justiça de Minas Gerais',
        value: 'TJ_MG',
      },
      {
        label: 'Tribunal de Justiça do Pará',
        value: 'TJ_PA',
      },
      {
        label: 'Tribunal de Justiça da Paraíba',
        value: 'TJ_PB',
      },
      {
        label: 'Tribunal de Justiça do Paraná',
        value: 'TJ_PR',
      },
      {
        label: 'Tribunal de Justiça de Pernambuco',
        value: 'TJ_PE',
      },
      {
        label: 'Tribunal de Justiça do Piauí',
        value: 'TJ_PI',
      },
      {
        label: 'Tribunal de Justiça do Rio de Janeiro',
        value: 'TJ_RJ',
      },
      {
        label: 'Tribunal de Justiça do Rio Grande do Norte',
        value: 'TJ_RN',
      },
      {
        label: 'Tribunal de Justiça do Rio Grande do Sul',
        value: 'TJ_RS',
      },
      {
        label: 'Tribunal de Justiça de Rondônia',
        value: 'TJ_RO',
      },
      {
        label: 'Tribunal de Justiça de Roraima',
        value: 'TJ_RR',
      },
      {
        label: 'Tribunal de Justiça de Santa Catarina',
        value: 'TJ_SC',
      },
      {
        label: 'Tribunal de Justiça de São Paulo',
        value: 'TJ_SP',
      },
      {
        label: 'Tribunal de Justiça de Sergipe',
        value: 'TJ_SE',
      },
      {
        label: 'Tribunal de Justiça do Tocantins',
        value: 'TJ_TO',
      },
    ],
  },
  {
    label: 'Tribunais Regionais Federais',
    value: 'TRF',
    children: [
      {
        label: 'Tribunal Regional Federal da 1ª Região',
        value: 'TRF_1',
      },
      {
        label: 'Tribunal Regional Federal da 2ª Região',
        value: 'TRF_2',
      },
      {
        label: 'Tribunal Regional Federal da 3ª Região',
        value: 'TRF_3',
      },
      {
        label: 'Tribunal Regional Federal da 4ª Região',
        value: 'TRF_4',
      },
      {
        label: 'Tribunal Regional Federal da 5ª Região',
        value: 'TRF_5',
      },
      {
        label: 'Tribunal Regional Federal da 6ª Região',
        value: 'TRF_6',
      },
    ],
  },
  {
    label: 'Tribunais Regionais do Trabalho',
    value: 'TRT',
    children: [
      {
        label: 'Tribunal Regional do Trabalho da 1ª Região',
        value: 'TRT_1',
      },
      {
        label: 'Tribunal Regional do Trabalho da 2ª Região',
        value: 'TRT_2',
      },
      {
        label: 'Tribunal Regional do Trabalho da 3ª Região',
        value: 'TRT_3',
      },
      {
        label: 'Tribunal Regional do Trabalho da 4ª Região',
        value: 'TRT_4',
      },
      {
        label: 'Tribunal Regional do Trabalho da 5ª Região',
        value: 'TRT_5',
      },
      {
        label: 'Tribunal Regional do Trabalho da 6ª Região',
        value: 'TRT_6',
      },
      {
        label: 'Tribunal Regional do Trabalho da 7ª Região',
        value: 'TRT_7',
      },
      {
        label: 'Tribunal Regional do Trabalho da 8ª Região',
        value: 'TRT_8',
      },
      {
        label: 'Tribunal Regional do Trabalho da 9ª Região',
        value: 'TRT_9',
      },
      {
        label: 'Tribunal Regional do Trabalho da 10ª Região',
        value: 'TRT_10',
      },
      {
        label: 'Tribunal Regional do Trabalho da 11ª Região',
        value: 'TRT_11',
      },
      {
        label: 'Tribunal Regional do Trabalho da 12ª Região',
        value: 'TRT_12',
      },
      {
        label: 'Tribunal Regional do Trabalho da 13ª Região',
        value: 'TRT_13',
      },
      {
        label: 'Tribunal Regional do Trabalho da 14ª Região',
        value: 'TRT_14',
      },
      {
        label: 'Tribunal Regional do Trabalho da 15ª Região',
        value: 'TRT_15',
      },
      {
        label: 'Tribunal Regional do Trabalho da 16ª Região',
        value: 'TRT_16',
      },
      {
        label: 'Tribunal Regional do Trabalho da 17ª Região',
        value: 'TRT_17',
      },
      {
        label: 'Tribunal Regional do Trabalho da 18ª Região',
        value: 'TRT_18',
      },
      {
        label: 'Tribunal Regional do Trabalho da 19ª Região',
        value: 'TRT_19',
      },
      {
        label: 'Tribunal Regional do Trabalho da 20ª Região',
        value: 'TRT_20',
      },
      {
        label: 'Tribunal Regional do Trabalho da 21ª Região',
        value: 'TRT_21',
      },
      {
        label: 'Tribunal Regional do Trabalho da 22ª Região',
        value: 'TRT_22',
      },
      {
        label: 'Tribunal Regional do Trabalho da 23ª Região',
        value: 'TRT_23',
      },
      {
        label: 'Tribunal Regional do Trabalho da 24ª Região',
        value: 'TRT_24',
      },
    ],
  },
  {
    label: 'Tribunal Superior Eleitoral',
    value: 'TSE',
  },
  {
    label: 'Tribunais Regionais Eleitorais',
    value: 'TRE',
    children: [
      {
        label: 'Tribunal Regional Eleitoral do Acre',
        value: 'TRE_AC',
      },
      {
        label: 'Tribunal Regional Eleitoral do Alagoas',
        value: 'TRE_AL',
      },
      {
        label: 'Tribunal Regional Eleitoral do Amapá',
        value: 'TRE_AP',
      },
      {
        label: 'Tribunal Regional Eleitoral do Amazonas',
        value: 'TRE_AM',
      },
      {
        label: 'Tribunal Regional Eleitoral da Bahia',
        value: 'TRE_BA',
      },
      {
        label: 'Tribunal Regional Eleitoral do Ceará',
        value: 'TRE_CE',
      },
      {
        label: 'Tribunal Regional Eleitoral do Distrito Federal',
        value: 'TRE_DF',
      },
      {
        label: 'Tribunal Regional Eleitoral do Espírito Santo',
        value: 'TRE_ES',
      },
      {
        label: 'Tribunal Regional Eleitoral de Goiás',
        value: 'TRE_GO',
      },
      {
        label: 'Tribunal Regional Eleitoral do Maranhão',
        value: 'TRE_MA',
      },
      {
        label: 'Tribunal Regional Eleitoral de Mato Grosso',
        value: 'TRE_MT',
      },
      {
        label: 'Tribunal Regional Eleitoral do Mato Grosso do Sul',
        value: 'TRE_MS',
      },
      {
        label: 'Tribunal Regional Eleitoral de Minas Gerais',
        value: 'TRE_MG',
      },
      {
        label: 'Tribunal Regional Eleitoral do Pará',
        value: 'TRE_PA',
      },
      {
        label: 'Tribunal Regional Eleitoral da Paraíba',
        value: 'TRE_PB',
      },
      {
        label: 'Tribunal Regional Eleitoral do Paraná',
        value: 'TRE_PR',
      },
      {
        label: 'Tribunal Regional Eleitoral de Pernambuco',
        value: 'TRE_PE',
      },
      {
        label: 'Tribunal Regional Eleitoral do Piauí',
        value: 'TRE_PI',
      },
      {
        label: 'Tribunal Regional Eleitoral do Rio de Janeiro',
        value: 'TRE_RJ',
      },
      {
        label: 'Tribunal Regional Eleitoral do Rio Grande do Norte',
        value: 'TRE_RN',
      },
      {
        label: 'Tribunal Regional Eleitoral do Rio Grande do Sul',
        value: 'TRE_RS',
      },
      {
        label: 'Tribunal Regional Eleitoral de Rondônia',
        value: 'TRE_RO',
      },
      {
        label: 'Tribunal Regional Eleitoral de Roraima',
        value: 'TRE_RR',
      },
      {
        label: 'Tribunal Regional Eleitoral de Santa Catarina',
        value: 'TRE_SC',
      },
      {
        label: 'Tribunal Regional Eleitoral de São Paulo',
        value: 'TRE_SP',
      },
      {
        label: 'Tribunal Regional Eleitoral de Sergipe',
        value: 'TRE_SE',
      },
      {
        label: 'Tribunal Regional Eleitoral do Tocantins',
        value: 'TRE_TO',
      },
    ],
  },
  {
    label: 'Superior Tribunal Militar',
    value: 'STM',
  },
  {
    label: 'Tribunais de Justiça Militar',
    value: 'TJM',
    children: [
      {
        label: 'Tribunal de Justiça Militar de Minas Gerais',
        value: 'TJM_MG',
      },
      {
        label: 'Tribunal de Justiça Militar do Rio Grande do Sul',
        value: 'TJM_RS',
      },
      {
        label: 'Tribunal de Justiça Militar de São Paulo',
        value: 'TJM_SP',
      },
    ],
  },
  {
    label: 'Tribunal de Contas da União',
    value: 'TCU',
  },
  {
    label: 'Tribunais de Contas dos Estados',
    value: 'TCE',
    children: [
      {
        label: 'Tribunal de Contas do Acre',
        value: 'TCE_AC',
      },
      {
        label: 'Tribunal de Contas do Alagoas',
        value: 'TCE_AL',
      },
      {
        label: 'Tribunal de Contas do Amapá',
        value: 'TCE_AP',
      },
      {
        label: 'Tribunal de Contas do Amazonas',
        value: 'TCE_AM',
      },
      {
        label: 'Tribunal de Contas da Bahia',
        value: 'TCE_BA',
      },
      {
        label: 'Tribunal de Contas do Ceará',
        value: 'TCE_CE',
      },
      {
        label: 'Tribunal de Contas do Distrito Federal',
        value: 'TCE_DF',
      },
      {
        label: 'Tribunal de Contas do Espírito Santo',
        value: 'TCE_ES',
      },
      {
        label: 'Tribunal de Contas de Goiás',
        value: 'TCE_GO',
      },
      {
        label: 'Tribunal de Contas do Maranhão',
        value: 'TCE_MA',
      },
      {
        label: 'Tribunal de Contas de Mato Grosso',
        value: 'TCE_MT',
      },
      {
        label: 'Tribunal de Contas do Mato Grosso do Sul',
        value: 'TCE_MS',
      },
      {
        label: 'Tribunal de Contas de Minas Gerais',
        value: 'TCE_MG',
      },
      {
        label: 'Tribunal de Contas do Pará',
        value: 'TCE_PA',
      },
      {
        label: 'Tribunal de Contas da Paraíba',
        value: 'TCE_PB',
      },
      {
        label: 'Tribunal de Contas do Paraná',
        value: 'TCE_PR',
      },
      {
        label: 'Tribunal de Contas de Pernambuco',
        value: 'TCE_PE',
      },
      {
        label: 'Tribunal de Contas do Piauí',
        value: 'TCE_PI',
      },
      {
        label: 'Tribunal de Contas do Rio de Janeiro',
        value: 'TCE_RJ',
      },
      {
        label: 'Tribunal de Contas do Rio Grande do Norte',
        value: 'TCE_RN',
      },
      {
        label: 'Tribunal de Contas do Rio Grande do Sul',
        value: 'TCE_RS',
      },
      {
        label: 'Tribunal de Contas de Rondônia',
        value: 'TCE_RO',
      },
      {
        label: 'Tribunal de Contas de Roraima',
        value: 'TCE_RR',
      },
      {
        label: 'Tribunal de Contas de Santa Catarina',
        value: 'TCE_SC',
      },
      {
        label: 'Tribunal de Contas de São Paulo',
        value: 'TCE_SP',
      },
      {
        label: 'Tribunal de Contas de Sergipe',
        value: 'TCE_SE',
      },
      {
        label: 'Tribunal de Contas do Tocantins',
        value: 'TCE_TO',
      },
    ],
  },
  {
    label: 'Turma Nacional de Uniformização',
    value: 'TNU',
  },
  {
    label: 'Turma Regional de Uniformização',
    value: 'TRU',
  },
  {
    label: 'Tribunal Administrativo Tributário do Mato Grosso do Sul',
    value: 'TAT_MS',
  },
  {
    label: 'Tribunal Administrativo Tributário de Santa Catarina',
    value: 'TAT_SC',
  },
  {
    label: 'Tribunal de Impostos e Taxas do Estado de São Paulo',
    value: 'TIT_SP',
  },
  {
    label: 'Conselho Administrativo Tributário do Estado de Goiás',
    value: 'CAT_GO',
  },
  {
    label: 'Conselho Nacional de Justiça',
    value: 'CNJ',
  },
  {
    label: 'Conselho de Adm. Recursos Fiscais',
    value: 'CARF',
  },
  {
    label: 'Agência Nacional de Aviação Civil',
    value: 'ANAC',
  },
  {
    label: 'Agência Nacional do Cinema',
    value: 'ANCINE',
  },
  {
    label: 'Agência Nacional de Energia Elétrica',
    value: 'ANEEL',
  },
  {
    label: 'Agência Nacional de Transportes Aquaviários',
    value: 'ANTAQ',
  },
  {
    label: 'Agência Nacional de Transportes Terrestres',
    value: 'ANTT',
  },
  {
    label: 'Conselho Administrativo de Defesa Econômica',
    value: 'CADE',
  },
  {
    label: 'Conselho Federal de Medicina',
    value: 'CFM',
  },
]

export const courtsMap = courts.reduce((acc, { value, label, isJudgingOrgan, children }) => {
  acc.set(value.toLowerCase(), {
    label,
    acronym: value.replace('_', '-'),
    hasChildren: !!children?.length,
    isJudgingOrgan: !!isJudgingOrgan,
  })

  children?.forEach((child) => {
    acc.set(child.value.toLowerCase(), {
      label: child.label,
      acronym: child.value.replace('_', '-'),
      hasChildren: !!child.children?.length,
      isJudgingOrgan: !!child.isJudgingOrgan,
    })

    child.children?.forEach((cc) => {
      acc.set(cc.value.toLowerCase(), {
        label: cc.label,
        acronym: cc.value.replace('_', '-'),
        isJudgingOrgan: !!cc.isJudgingOrgan,
      })
    })
  })

  return acc
}, new Map())
